import _defineProperty from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _typeof from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/typeof.js";
import React from "react";
var __jsx = React.createElement;
import { Fragment } from "react";
import { Listbox, Transition } from "@headlessui/react";
import classNames from "classnames";
import { get, isEqual, truncate } from "lodash";
import AwesomeIcon from "../AwesomeIcon";
import { faCheck, faAnglesUpDown } from "@fortawesome/pro-regular-svg-icons";
import { useTranslation } from "react-i18next";
var SelectInput = function SelectInput(props) {
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var label = props.label,
    _props$className = props.className,
    className = _props$className === void 0 ? "" : _props$className,
    _props$options = props.options,
    options = _props$options === void 0 ? [] : _props$options,
    value = props.value,
    _onChange = props.onChange,
    disabled = props.disabled,
    required = props.required,
    placeholder = props.placeholder,
    multiple = props.multiple,
    isClinicalField = props.isClinicalField,
    _props$labelClassName = props.labelClassName,
    labelClassName = _props$labelClassName === void 0 ? "" : _props$labelClassName,
    responseType = props.responseType,
    _props$dataTestId = props.dataTestId,
    dataTestId = _props$dataTestId === void 0 ? "" : _props$dataTestId;
  var selected = multiple ? Array.isArray(value) ? value.map(function (opt) {
    return options === null || options === void 0 ? void 0 : options.find(function (op) {
      return op.value === opt;
    });
  }).filter(Boolean) : [] : options === null || options === void 0 ? void 0 : options.find(function (opt) {
    if (_typeof(value) === "object" && value !== null && "value" in value) {
      return opt.value === value.value || isEqual(opt, value);
    }
    return opt.value === value || isEqual(opt, value);
  });
  var selectedLabel = multiple ? "".concat(selected.length, " selected") : get(selected, ["label"], placeholder);
  var renderField = function renderField() {
    return /*#__PURE__*/React.createElement("div", {
      className: classNames("relative flex items-center rounded-md ", _defineProperty({
        "opacity-50": disabled,
        "border border-gray-500 dark:border-0 dark:bg-gray-800": isClinicalField,
        "border border-gray-500": !isClinicalField
      }, className, !!className))
    }, /*#__PURE__*/React.createElement(Listbox, {
      multiple: multiple,
      disabled: disabled,
      value: selected,
      onChange: function onChange(obj) {
        if (_onChange) {
          _onChange(responseType === "dropdown" ? obj : obj.value);
        }
      }
    }, function (_ref) {
      var open = _ref.open;
      return /*#__PURE__*/React.createElement(React.Fragment, null, !!label && /*#__PURE__*/React.createElement(Listbox.Label, {
        className: classNames("text-md", _defineProperty({
          "dark:bg-gray-800 bg-gray-200 z-10 absolute left-4 -top-3 px-4": !isClinicalField,
          hidden: isClinicalField
        }, labelClassName, !!labelClassName))
      }, label, " ", !!required && /*#__PURE__*/React.createElement("span", {
        className: "text-red-500 pl-2"
      }, "*")), /*#__PURE__*/React.createElement("div", {
        className: "relative w-full h-full"
      }, /*#__PURE__*/React.createElement(Listbox.Button, {
        className: classNames("relative w-full h-full rounded-md py-2 pl-3 text-left cursor-pointer", {
          "!cursor-not-allowed": disabled,
          "h-6": !selectedLabel,
          "!py-3": isClinicalField
        }),
        "data-testid": dataTestId
      }, /*#__PURE__*/React.createElement("span", {
        className: classNames("flex gap-3 truncate", {
          "text-gray-400": !selected
        }),
        title: t(selectedLabel)
      }, !!(selected !== null && selected !== void 0 && selected.icon) && /*#__PURE__*/React.createElement("div", {
        className: ""
      }, selected === null || selected === void 0 ? void 0 : selected.icon), truncate(t(selectedLabel), {
        length: 30
      })), /*#__PURE__*/React.createElement("span", {
        className: "pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2"
      }, /*#__PURE__*/React.createElement(AwesomeIcon, {
        name: faAnglesUpDown,
        size: "xs",
        className: "w-5 text-gray-400"
      }))), /*#__PURE__*/React.createElement(Transition, {
        show: open,
        as: Fragment,
        leave: "transition ease-in duration-100",
        leaveFrom: "opacity-100",
        leaveTo: "opacity-0"
      }, /*#__PURE__*/React.createElement(Listbox.Options, {
        className: "absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-gray-600 dark:bg-gray-700 text-white text-base shadow-lg border border-gray-600 text-left scrollbar-light dark:scrollbar"
      }, options === null || options === void 0 ? void 0 : options.map(function (option, index) {
        return /*#__PURE__*/React.createElement(Listbox.Option, {
          key: (option === null || option === void 0 ? void 0 : option.id) || index,
          className: function className(_ref2) {
            var selected = _ref2.selected;
            return classNames("flex justify-between relative cursor-default select-none py-2 px-3 hover:bg-teal-800", {
              "bg-gray-600": selected
            });
          },
          value: option
        }, function (_ref3) {
          var selected = _ref3.selected,
            active = _ref3.active;
          return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
            className: "flex gap-3 truncate",
            "data-testid": dataTestId ? "".concat(dataTestId, "-").concat(option === null || option === void 0 ? void 0 : option.label) : ""
          }, !!(option !== null && option !== void 0 && option.icon) && /*#__PURE__*/React.createElement("div", {
            className: ""
          }, option === null || option === void 0 ? void 0 : option.icon), t(option === null || option === void 0 ? void 0 : option.label)), multiple && selected && /*#__PURE__*/React.createElement(AwesomeIcon, {
            name: faCheck,
            className: "text-teal-400"
          })
          // <CheckIcon className="h-5 w-5 text-teal-400" />
          );
        });
      })))));
    }));
  };
  if (isClinicalField) {
    return /*#__PURE__*/React.createElement("div", {
      className: "flex flex-col py-3 px-2"
    }, /*#__PURE__*/React.createElement("div", {
      className: classNames("flex mb-5 text-left text-md", _defineProperty({
        "opacity-50": disabled
      }, labelClassName, !!labelClassName))
    }, label, " ", !!required && /*#__PURE__*/React.createElement("span", {
      className: "text-red-500 pl-2"
    }, "*")), renderField());
  } else {
    return renderField();
  }
};
export default SelectInput;